'use client';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { Button } from '@mui/material';

// import { companyRegisterSchema } from 'src/utils/validations';

import { Form, Field } from 'src/components/hook-form';
import { createSchemas } from 'src/utils/use-validations';
import { useLocale } from 'src/locales';

export function CompanyRegister({ open, registerCompany, loading }) {
  const defaultValues = {
    companyName: '',
    companyEmail: '',
    vatNumber: '',
    responsiblePersonName: '',
  };
  const { companyRegisterSchema } = createSchemas();
  const { t } = useLocale();

  const methods = useForm({
    resolver: zodResolver(companyRegisterSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting, isValid },
  } = methods;

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  const onSubmit = handleSubmit(async (data) => {
    registerCompany({
      companyName: data.companyName,
      companyEmail: data.companyEmail,
      vatNumber: data.vatNumber,
      responsiblePersonName: data.responsiblePersonName,
    });
  });

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Field.Text name="companyName" label={t('Company_Name')} required sx={{ my: 2 }} />
      <Field.Text
        name="responsiblePersonName"
        label={t('Responsible_Person_Name')}
        required
        sx={{ my: 2 }}
      />
      <Field.Text name="companyEmail" label={t('Company_Email')} required sx={{ my: 2 }} />
      <Field.Text name="vatNumber" label={t('VAT_Number')} required sx={{ my: 2 }} />

      <Button
        fullWidth
        color="primary"
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        disabled={isSubmitting || loading}
        sx={{
          '& .MuiCircularProgress-root': {
            color: '#0d9d57', // change loader colour here
            width: '20px !important',
            height: '20px !important',
          },
        }}
      >
        {t('Create_Account')}
      </Button>
    </Form>
  );
}
